import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

export type AnnouncementPriority = 'Low' | 'Normal' | 'High'

export interface Announcement {
  announcementId: number
  title: string
  message: string | null
  priority: AnnouncementPriority
  startsAt: string | null
  endsAt: string | null
  createdDate: string
  createdByName: string | null
}

export interface AnnouncementAdmin extends Announcement {
  state: 'Scheduled' | 'Showing' | 'Ended'
  dismissedCount: number
}

export interface SaveAnnouncement {
  title: string
  message: string | null
  priority: AnnouncementPriority
  startsAt: Date | null
  endsAt: Date | null
}

/** Fired after an announcement is saved here, so the banner picks it up at once. */
export const ANNOUNCEMENTS_CHANGED = 'announcements:changed'

const headers = () => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    throw new Error('Authorization token not found')
  }
  return { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }
}

const base = () => `https://${apiURL}/Announcements`

/** What the signed-in user should see now, highest priority first. */
export const getActiveAnnouncements = async (): Promise<Announcement[]> =>
  (await axios.get(`${base()}/Active`, { headers: headers() })).data

export const dismissAnnouncement = async (id: number): Promise<void> => {
  await axios.post(`${base()}/${id}/Dismiss`, {}, { headers: headers() })
}

export const getAllAnnouncements = async (): Promise<AnnouncementAdmin[]> =>
  (await axios.get(base(), { headers: headers() })).data

export const saveAnnouncement = async (id: number | null, announcement: SaveAnnouncement): Promise<AnnouncementAdmin> => {
  const result = id
    ? (await axios.put(`${base()}/${id}`, announcement, { headers: headers() })).data
    : (await axios.post(base(), announcement, { headers: headers() })).data
  window.dispatchEvent(new Event(ANNOUNCEMENTS_CHANGED))
  return result
}

export const endAnnouncement = async (id: number): Promise<void> => {
  await axios.post(`${base()}/${id}/End`, {}, { headers: headers() })
  window.dispatchEvent(new Event(ANNOUNCEMENTS_CHANGED))
}

export const deleteAnnouncement = async (id: number): Promise<void> => {
  await axios.delete(`${base()}/${id}`, { headers: headers() })
  window.dispatchEvent(new Event(ANNOUNCEMENTS_CHANGED))
}
